export default class Month {
  id: number // 1..13 (Nissan=1, Tishrei=7, Adar/AdarI=12, AdarII=13)

  name: string // "תשרי", "ניסן", etc.

  numericYear: number // 5785, 5786...

  textYear: string // 'תשפ"ה', 'תשפ"ו'

  constructor(month: any) {
    this.id = month.id
    this.name = month.name
    this.numericYear = month.numericYear ?? month.year
    this.textYear = month.textYear ?? ''
  }
}
